/** @format */

import React from "react";
import CountUp from "react-countup";

function Features() {
  return (
    <>
      {/* Page Header Start */}
      <div className="container-fluid page-header py-5 mb-5">
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">
            Features
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Pages
                </a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Features
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}
      {/* Feature Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={3453} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Happy Customers</h5>
              <span>
                "I was so impressed with the quality of your product and the
                level of customer service I received. I will definitely be
                recommending your business to my friends and family." - John
                Smith
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-check text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={4234} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Project Done</h5>
              <span>
                1. The goals of the project and whether they were achieved.{" "}
                <br />
                2. The challenges that were faced and how they were overcome.{" "}
                <br />
                3. The impact of the project on the stakeholders and the
                community. <br />
                4. The lessons learned from the project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-award text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={3123} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Awards Win</h5>
              <span>
                1. The name of the award and the organization that presented it.{" "}
                <br />
                2. What the award is for. <br />
                3. Why your company or project was chosen for the award. <br />
                4. The impact of the award on your company or project.
              </span>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
              <div className="d-flex align-items-center mb-4">
                <div className="btn-lg-square bg-primary rounded-circle me-3">
                  <i className="fa fa-users-cog text-white" />
                </div>
                <h1 className="mb-0" data-toggle="counter-up">
                  <CountUp end={1831} enableScrollSpy />
                </h1>
              </div>
              <h5 className="mb-3">Expert Workers</h5>
              <span>
                John Smith is a senior engineer at our company with over 20
                years of experience in the field of renewable energy. He has
                worked on a wide range of projects, from small-scale residential
                solar systems to large-scale commercial wind farms. John is an
                expert in all aspects of renewable energy, from design and
                engineering to installation and maintenance.
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Feature Start */}
      {/* Feature Start */}
      <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
        <div className="container feature px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 feature-text py-5 wow fadeIn"
              data-wow-delay="0.1s"
            >
              <div className="p-lg-5 ps-lg-0">
                <h6 className="text-primary">Why Choose Us!</h6>
                <h1 className="mb-4">
                  Complete Commercial &amp; Residential Solar Systems
                </h1>
                <p className="mb-4 pb-2">
                  {" "}
                  We are experts in renewable energy. We have a team of
                  experienced and certified professionals who are passionate
                  about renewable energy. We can help you choose the right
                  renewable energy system for your needs and budget, and we can
                  install and maintain your system to the highest standards.{" "}
                  <br />
                  We offer a wide range of renewable energy solutions. We can
                  provide you with solar panels, wind turbines, hydropower
                  systems, and biomass systems. We also offer energy storage
                  solutions to help you save money on your energy bills and to
                  reduce your reliance on the grid. <br />
                  We are committed to providing our customers with the best
                  possible service. We work closely with our customers to
                  understand their needs and to develop a renewable energy
                  solution that is right for them. We also offer comprehensive
                  warranties on all of our products and services.
                </p>
                <div className="row g-4">
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Quality</p>
                        <h5 className="mb-0">Services</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-user-check text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Expert</p>
                        <h5 className="mb-0">Workers</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-drafting-compass text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Free</p>
                        <h5 className="mb-0">Consultation</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle">
                        <i className="fa fa-headphones text-white" />
                      </div>
                      <div className="ms-4">
                        <p className="mb-0">Customer</p>
                        <h5 className="mb-0">Support</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 pe-lg-0 wow fadeIn"
              data-wow-delay="0.5s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute img-fluid w-100 h-100"
                  src="img/feature.jpg"
                  style={{ objectFit: "cover" }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Feature End */}
    </>
  );
}

export default Features;
